/* Election client data model
 *
 */

import moment from "moment-timezone";

import makePropsEnumerable from "../utility/MakePropsEnumerable";

const mElectionMoment = new WeakMap();

function ProcessDateParam(dateParam) {
    let electionMomentParam = null;
    if (dateParam != null) {
        if (moment.isMoment(dateParam)) {
            electionMomentParam = dateParam.clone().tz("UTC");
        }
        else if (moment.isDate(dateParam)) {
            electionMomentParam = moment(dateParam).tz("UTC");
        }
    }

    if (electionMomentParam != null) {
        return electionMomentParam;
    }
    else {
        throw new TypeError("Invalid or missing election date");
    }
}

class Election {
    constructor(
        electionId,
        electionType,
        electionDate,
        electionOffice,
        electionCandidates,
        electionSubscribers
    )
    {
        if (Number.isInteger(electionId))
        {
            this.electionId = electionId;
        }
        else {
            throw new TypeError("Invalid or missing required election id");
        }

        if ((electionType != null) &&
            //electionType is duck-typed as an ElectionType object.
            (angular.isDefined(electionType.electionTypeName)))
        {
            this.electionType = electionType;
        }
        else {
            throw new TypeError("Invalid or missing election type");
        }

        mElectionMoment.set(this, ProcessDateParam(electionDate));

        // We could require this,
        // but when election is in a hierarchy
        // as a child of a Office object,
        // having the reference creates a loop.
        // Any class instance methods will need to ensure
        // they handle this behavior.
        this.electionOffice = null;

        if ((electionOffice != null) &&
            (angular.isDefined(electionOffice.officeType)))
        {
            this.electionOffice = electionOffice;
        }

        this.electionCandidates = [];

        if ((electionCandidates != null) &&
            (angular.isArray(electionCandidates)))
        {
            Array.prototype.push.apply(this.electionCandidates, electionCandidates);
        }

        this.electionSubscribers = [];

        if ((electionSubscribers != null) &&
            (angular.isArray(electionSubscribers)))
        {
            Array.prototype.push.apply(this.electionSubscribers, electionSubscribers);
        }

    }

    toString() {
        return `${this.electionType.electionTypeName}-${(this.electionOffice || "(parent)")} (${this.electionId})`;
    }

    valueOf() {
        return this.electionId;
    }

    get electionDate() {
        return mElectionMoment.get(this).toDate();
    }

    set electionDate(eDate) {
        const updatedElectionDate = ProcessDateParam(eDate);
        mElectionMoment.set(this, updatedElectionDate);
    }

    get electionName() {

        let electionNameParts = [];

        let electionDateStr = mElectionMoment.get(this).format("MMMM D, YYYY");
        electionNameParts.push(electionDateStr);

        if (this.electionOffice == null) {
            electionNameParts.push("(" + this.electionType.electionTypeName + ")");
        }
        else {
            electionNameParts.push(this.electionType.electionTypeName);
            electionNameParts.push("Election: ");
            electionNameParts.push(this.electionOffice.displayName);
        }

        return electionNameParts.join(" ");
    }

    get displayName() {
        return this.electionName;
    }

    get sortAs() {
        return String(this.electionDate.getTime()) +
            (this.electionOffice == null ? "Unknown" : this.electionOffice.sortAs);
    }

    get subscribableId() {
        return this.electionId;
    }
}

makePropsEnumerable(Election.prototype, [
    "electionDate",
    "electionName",
    "displayName",
    "sortAs",
    "subscribableId"
]);


export default Election;



//////////////////
// WEBPACK FOOTER
// ./src/models/Election.js
// module id = TdK8
// module chunks = 1